// extracted by mini-css-extract-plugin
export default {"footerWrapper":"styles_footerWrapper__qOkUY","footerWrapper_cefx":"styles_footerWrapper_cefx__WTn21","containerLogos":"styles_containerLogos__JGJjH"};